var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","display":"flex"}},[(_vm.realTime)?_c('video',{ref:"webrtcVideo",staticClass:"video-element",attrs:{"autoplay":"","playsinline":"","muted":""},domProps:{"muted":true}}):_c('video',{ref:"videoPlayer",staticClass:"video-element video-js"})])
}
var staticRenderFns = []

export { render, staticRenderFns }